import MatchedMap from 'utilities/src/matchedMap';

import { SiteVariantEnum } from '../../_variants';
import { SiteSizeEnum, type SiteSizeType } from '../../_size';

const buttonClassesMap = new MatchedMap([
  [SiteVariantEnum.Primary, 'text-site-neutrals-0'],
  [SiteVariantEnum.Secondary, 'border-site-secondary-green-600 disabled:text-site-neutrals-500'],
  [SiteVariantEnum.Tertiary, 'text-site-secondary-green-600'],
  [SiteVariantEnum.TextOnly, 'text-site-secondary-green-600'],
]);

const buttonHoverClassesMap = new MatchedMap([
  [SiteVariantEnum.Primary, ''],
  [SiteVariantEnum.Secondary, 'hover:bg-site-secondary-green-600 hover:text-site-neutrals-0'],
  [SiteVariantEnum.Tertiary, ''],
  [SiteVariantEnum.TextOnly, 'hover:text-site-secondary-green-500'],
]);

const buttonActiveClassesMap = new MatchedMap([
  [SiteVariantEnum.Primary, 'active:bg-site-secondary-green-800'],
  [SiteVariantEnum.Secondary, 'active:border-site-secondary-green-800'],
  [SiteVariantEnum.Tertiary, 'active:text-site-secondary-green-800'],
  [SiteVariantEnum.TextOnly, 'active:text-site-secondary-green-800'],
]);

const buttonShadowClasses = 'focus:shadow-site-secondary-green-200';

/**
 * Size per Variants
 */

const buttonPrimarySizeClassesMap = new MatchedMap([
  [SiteSizeEnum.Small, 'bg-site-secondary-green-700 hover:bg-site-secondary-green-600'],
  [SiteSizeEnum.Medium, 'bg-site-secondary-green-700 hover:bg-site-secondary-green-600'],
  [SiteSizeEnum.Large, 'bg-site-secondary-green-600 hover:bg-site-secondary-green-800'],
  [SiteSizeEnum.XLarge, 'bg-site-secondary-green-600 hover:bg-site-secondary-green-800'],
]);

/**
 * Site Theme / Green Dark Button Size Variant
 */

const buttonSizeClassesMap = (size: SiteSizeType) =>
  new MatchedMap([
    [SiteVariantEnum.Primary, buttonPrimarySizeClassesMap.get(SiteSizeEnum[size])],
    [SiteVariantEnum.Secondary, ''],
    [SiteVariantEnum.Tertiary, ''],
    [SiteVariantEnum.TextOnly, ''],
  ]);

/**
 * Site Theme / Green Dark Button Color Variant
 */

const buttonSiteGreenDarkTheme = (size: SiteSizeType) => ({
  buttonSiteVariantColorClasses: [
    buttonClassesMap,
    buttonHoverClassesMap,
    buttonActiveClassesMap,
    buttonSizeClassesMap(size),
  ],
  buttonSiteVariantColorShadowClasses: buttonShadowClasses,
});

export default buttonSiteGreenDarkTheme;
